import { reactive } from 'vue'

export const authStore = reactive({
  user: null,
  token: null,
  isAuthenticated: false,

  init() {
    const token = localStorage.getItem('auth_token')
    const user = localStorage.getItem('user')
    
    if (token && user) {
      this.token = token
      this.user = JSON.parse(user)
      this.isAuthenticated = true
    }
  },

  login(token, user) {
    this.token = token
    this.user = user
    this.isAuthenticated = true
    localStorage.setItem('auth_token', token)
    localStorage.setItem('user', JSON.stringify(user))
  },

  logout() {
    this.token = null
    this.user = null
    this.isAuthenticated = false
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user')
  }
})